import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/sportsMeeting/Index.vue')
const Trend = () => import('../activity/sportsMeeting/Trend.vue')
const Kaishu = () => import('../activity/sportsMeeting/Kaishu.vue')
const LiveStation = () => import('../activity/sportsMeeting/LiveStation.vue')
const RankingBoardIndex = () => import('../activity/sportsMeeting/RankingBoardIndex.vue')
const RankingBoardDetail = () => import('../activity/sportsMeeting/RankingBoardDetail.vue')
const RankingBoardTeacherIndex = () => import('../activity/sportsMeeting/RankingBoardTeacherIndex.vue')
const RankingBoardTeacherDetail = () => import('../activity/sportsMeeting/RankingBoardTeacherDetail.vue')

export const sportsMeetingRoute: RouteConfig = {
  path: '/sports-meeting',
  name: 'sports_meeting',
  component: Index,
  meta: {
    title: '云上运动会',
  },
}

export const sportsMeetingTrendRoute: RouteConfig = {
  path: '/sports-meeting-trend',
  name: 'sports_meeting_trend',
  component: Trend,
  meta: {
    title: '学校火力榜',
  },
}

export const sportsMeetingKaishuRoute: RouteConfig = {
  path: '/sports-meeting-kaishu',
  name: 'sports_meeting_kaishu',
  component: Kaishu,
  meta: {
    title: '颁奖台 - 凯叔讲故事',
  },
}

export const sportsMeetingTeacherRoute: RouteConfig = {
  path: '/sports-meeting-teacher',
  name: 'sports_meeting_teacher',
  component: () => import('../activity/sportsMeeting/Teacher.vue'),
  meta: {
    title: '教师分会场',
  },
}

export const sportsMeetingRostrumRoute: RouteConfig = {
  path: '/sports-meeting-rostrum',
  name: 'sports_meeting_rostrum',
  component: () => import('../activity/sportsMeeting/Rostrum.vue'),
  meta: {
    title: '颁奖台',
  },
}

export const sportsMeetingRankingBoard: RouteConfig = {
  path: '/sports-meeting-ranking-board',
  name: 'sports_meeting_ranking_board',
  component: RankingBoardIndex,
  meta: {
    title: '排行榜',
  },
}

export const sportsMeetingRankingBoardDetail: RouteConfig = {
  path: '/sports-meeting-ranking-board-detail',
  name: 'sports_meeting_ranking_detail',
  component: RankingBoardDetail,
  meta: {
    title: '排行榜',
  },
}

export const sportsMeetingRankingBoardTeacher: RouteConfig = {
  path: '/sports-meeting-ranking-board-teacher',
  name: 'sports_meeting_ranking_board_teacher',
  component: RankingBoardTeacherIndex,
  meta: {
    title: '排行榜',
  },
}

export const sportsMeetingRankingBoardTeacherDetail: RouteConfig = {
  path: '/sports-meeting-ranking-board-teacher-detail',
  name: 'sports_meeting_ranking_teacher_detail',
  component: RankingBoardTeacherDetail,
  meta: {
    title: '排行榜',
  },
}

export const sportsMeetingLiveStation: RouteConfig = {
  path: '/sports-meeting-live-station',
  name: 'sports_meeting_live_station',
  component: LiveStation,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '直播台',
  },
}

export default [
  sportsMeetingRoute,
  sportsMeetingTrendRoute,
  sportsMeetingKaishuRoute,
  sportsMeetingTeacherRoute,
  sportsMeetingRostrumRoute,
  sportsMeetingRankingBoard,
  sportsMeetingRankingBoardDetail,
  sportsMeetingRankingBoardTeacher,
  sportsMeetingRankingBoardTeacherDetail,
  sportsMeetingLiveStation,
]
